import {
  KeyframedMoviePath,
  KeyframedValue,
  MoviePath,
  SimpleValue,
  Value,
} from '../moviePrimitives.types';

function isSimpleValue<G>(val: Value<G>): val is SimpleValue<G> {
  return val && 'val' in val && !!val.val;
}

function isKeyframedValue<G>(val: Value<G>): val is KeyframedValue<G> {
  return val && 'k' in val && !!val.k;
}

function isKeyframedPath(path: MoviePath | KeyframedMoviePath): path is KeyframedMoviePath {
  return 'k' in path && !!path.k;
}

export {isSimpleValue, isKeyframedValue, isKeyframedPath}; 